import { Route } from "react-router-dom";
import { ChatScreen } from "./ChatScreen";

export const routes = <Route path="/chat/:uuid?" element={<ChatScreen />} />;
